<div class="dialog-content-wrapper" fusePerfectScrollbar>
  <div mat-dialog-title>
    <div class="text-truncate title dialog-title" i18n>Список ошибок</div>
    <button mat-button class="mat-icon-button" (click)="dialogRef.close(undefined)" aria-label="Close dialog">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div mat-dialog-content class="p-4" fusePerfectScrollbar>
    <ul class="flex flex-col gap-2">
      <li *ngFor="let error of data" i18n>{{ error }}</li>
    </ul>
  </div>
</div>
